module.exports = require("./dua.d.ts");